import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";


const STATE_COPY = {
  loading: {
    title: "Loading protected reader",
    body: "Checking your access and preparing the in-portal reading view.",
  },
  access_required: {
    title: "Access required",
    body: "You do not have reading access for this module.",
  },
  access_removed: {
    title: "Access removed",
    body: "Your reading access was removed while this session was open. Please contact support if you need help.",
  },
  content_not_available: {
    title: "Content not available yet",
    body: "This module has been granted, but the protected reading content has not been uploaded yet.",
  },
  not_available: {
    title: "Reader not available",
    body: "Reading is not available for this module yet.",
  },
  error: {
    title: "Reader unavailable",
    body: "We could not load the protected reader right now.",
  },
};


export const ModuleReaderState = ({ variant, message }) => {
  const copy = STATE_COPY[variant] || STATE_COPY.error;
  return (
    <Card className="border-stone-200/80 bg-white/92 shadow-none" data-testid={`module-reader-state-${variant}-card`}>
      <CardHeader>
        <CardTitle className="text-[2rem] font-semibold leading-tight tracking-[-0.02em] text-slate-950" data-testid="module-reader-state-title">
          {copy.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <p className="text-sm leading-7 text-slate-600" data-testid="module-reader-state-body">{message || copy.body}</p>
        <Button asChild className="rounded-full bg-[#1f2d3d] hover:bg-[#15212d]" data-testid="module-reader-state-back-button">
          <Link to="/student">Back to student portal</Link>
        </Button>
      </CardContent>
    </Card>
  );
};
